export default __webpack_public_path__ + "static/media/FoldFlash.2e2f98b5.wav";